import React, { useEffect, useState } from 'react';
import LoaderSpinner from '../common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from '../common/DataTable';
import { numOfPage, UserRequestColumns } from '../../constant';
import BatchPagination from '../batch/BatchPagination';
import { approveUserSignup, getAllPendingUserList, getWhatsAppMsg, rejectUserSignup, sendPendingUserEmail } from '../../store/actions';
import { toast } from "react-toastify";
import Modal from '@material-ui/core/Modal';
import UserOnboarding from '../UserOnboarding';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

/* istanbul ignore next */
const UserRequest = () => {
    const [loader, setLoader] = useState(false);
    const { allPendingUsersDataStatus, allPendingUsersData } = useSelector((state) => state.UsersReducer);
    const [usersList, setUsersList] = useState([]);
    const [showUserRequest, setShowUserRequest] = useState({
        show: false,
        data: null,
    });
    let dispatch = useDispatch();
    let dataLoad = {
        pageIndex: 1,
        pageSize: 30,
        sortColumn: '',
        sortOrder: 'ASCENDING',
        searchkey: '',
    };
    const [filterData, setfilterData] = useState(dataLoad);

    useEffect(() => {
        fetchAllList();
    }, [filterData.numberOfPage, filterData.pageIndex, filterData.pageSize, filterData.sortColumn, filterData.sortOrder]);

    useEffect(() => {
        if (allPendingUsersDataStatus === 'PENDING') {
            setLoader(true);
        } else if (allPendingUsersDataStatus === 'SUCCESS') {
            setLoader(false);
        }
    }, [allPendingUsersDataStatus]);

    useEffect(() => {
        if (allPendingUsersData?.usersList) {
            let addlistIndex = allPendingUsersData?.usersList.map((item, index) => ({
                ...item,
                listIndex: index,
                isChecked: false,
            }));
            setUsersList(addlistIndex);
            if (allPendingUsersDataStatus === 'SUCCESS') {
                setfilterData({
                    ...filterData,
                    totalPages: Math.ceil(allPendingUsersData?.TotalRecords / filterData.pageSize),
                });
            }
        }
    }, [allPendingUsersData]);

    const handleSortingColumn = (key) => {
        let newSortOrder = filterData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
        setfilterData({
            ...filterData,
            sortColumn: key,
            sortOrder: newSortOrder,
        });
    };

    const handleAction = async (item, type) => {
        let payloadData = {
            pendingSignupId: item.Id,
        }
        if (type === 'approve') {
            setLoader(true);
            let signupRes = await approveUserSignup(payloadData);
            if (signupRes?.data?.Status === 200) {
                toast.success('User approved successfully');
            } else {
                toast.error(signupRes?.data?.Message?.AppStatusDescription || 'Failed to approve user');
            }
            setLoader(false);
        } else if (type === 'delete') {
            setLoader(true);
            let rejectSignupRes = await rejectUserSignup(payloadData);
            if (rejectSignupRes?.data?.Status === 200) {
                toast.success('Request rejected');
            } else {
                toast.error(rejectSignupRes?.data?.Message?.AppStatusDescription || 'Failed to reject request');
            }
            setLoader(false);
        } else if (type === 'viewRequest') {
            setShowUserRequest({
                show: true,
                data: item,
            });
            return
        } else if (type === 'whatsApp') {
            handleWhatsApp(item);
            return;
        } else if (type === 'sendEmail') {
            handleSendEmail(item);
            return;
        }
        fetchAllList();
    };

    const handleWhatsApp = async (item) => {
        try {
            setLoader(true);
            let response = await getWhatsAppMsg(item.Id);
            if (response?.data?.Status === 200) {
                const message = response.data.Entity;
                let phoneNum = item.PhoneNumber.replaceAll(/\D/g, ''); // Remove non-digit characters
                const whatsappUrl = `https://wa.me/${phoneNum}?text=${encodeURIComponent(message)}`;
                window.open(whatsappUrl, '_blank');
            } else {
                toast.error(response?.data?.Message?.AppStatusDescription || 'Failed to get WhatsApp message content');
            }
            setLoader(false);
        } catch (error) {
            toast.error('Failed to get WhatsApp message content');
            setLoader(false);
        }
    };

    const handleSendEmail = async (item) => {
        try {
            let response = await sendPendingUserEmail(item.Id);
            if (response?.data?.Status === 200) {
                toast.success('Email sent successfully');
            } else {
                toast.error(response?.data?.Message?.AppStatusDescription || 'Failed to send email');
            }
        } catch (error) {
            toast.error('Failed to send email');
        }
    };

    const fetchAllList = () => {
        dispatch(getAllPendingUserList(filterData));
    };

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec">
                    User Requests
                </div>
                {loader && (<div className="full-screen-spinner-overlay"><LoaderSpinner /></div>)}
                <div className="main_content_table_history">
                    <div className="tableFixHead pl-2 zIndex1">
                        {allPendingUsersDataStatus === 'SUCCESS' && (
                            <DataTable
                                headers={UserRequestColumns}
                                tableData={usersList}
                                actionType={8}
                                handleAction={handleAction}
                                handleSortingColumn={handleSortingColumn}
                                tableDataStatus={allPendingUsersDataStatus}
                                filterData={filterData}
                            />
                        )}
                    </div>
                </div>
                <BatchPagination
                    gridData={usersList}
                    totalVisualRecords={usersList?.length}
                    numberOfPage={filterData.pageSize}
                    numOfPage={numOfPage}
                    loader={loader}
                    currentPage={filterData.pageIndex}
                    totalPages={filterData.totalPages}
                    totalRecords={allPendingUsersData?.TotalRecords || 0}
                    setCurrentPage={(value) => setfilterData({ ...filterData, pageIndex: value })}
                    setNumberOfPage={(value) => setfilterData({ ...filterData, pageSize: value, pageIndex: 1 })}
                />
            </div>
            {showUserRequest.show && (
                <Dialog
                    open={showUserRequest.show}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    fullWidth
                    maxWidth="lg"
                    onClose={() => setShowUserRequest({ show: false, data: null })}
                    scroll="paper"
                >
                    <DialogContent className="onboardingFormWrapping" dividers>
                        <UserOnboarding isViewUserRequest={true} data={showUserRequest.data} close={() => setShowUserRequest({ show: false, data: null })} />
                    </DialogContent>
                </Dialog>
            )}
        </main>
    );
}

export default UserRequest;
